
import React from "react";
import { lazy } from "react";
import { withErrorBoundary } from "@/utils/routeUtils";

const Blog = lazy(() => import("@/pages/knowledge/Blog"));
const BlogManagement = lazy(() => import("@/pages/knowledge/BlogManagement"));
const AccountSetup = lazy(() => import("@/pages/knowledge/AccountSetup"));
const AssessmentGuide = lazy(() => import("@/pages/knowledge/AssessmentGuide"));
const BestPractices = lazy(() => import("@/pages/knowledge/BestPractices"));
const CarePlanning = lazy(() => import("@/pages/knowledge/CarePlanning"));
const GettingStarted = lazy(() => import("@/pages/knowledge/GettingStarted"));

console.log('Knowledge routes loaded');

export const knowledgeRoutes = [
  {
    path: "/knowledge/blog",
    element: withErrorBoundary(<Blog />),
  },
  {
    path: "/knowledge/account-setup",
    element: withErrorBoundary(<AccountSetup />),
  },
  {
    path: "/knowledge/assessment-guide",
    element: withErrorBoundary(<AssessmentGuide />),
  },
  {
    path: "/knowledge/best-practices",
    element: withErrorBoundary(<BestPractices />),
  },
  {
    path: "/knowledge/care-planning",
    element: withErrorBoundary(<CarePlanning />),
  },
  {
    path: "/knowledge/getting-started",
    element: withErrorBoundary(<GettingStarted />),
  },
];
